const state = {
  currentIndex: -1,
  showTask: false, // 显示任务
  showWaterArea: false, // 显示水源保护区
  showEcologicalLine: false, // 显示生态控制线
  showNatureReserve: false, // 显示自然保护区
  showPumpStation: false, // 显示泵站
  showOutLet: false, // 显示排污口
  showEnterprise: false, // 显示企业
  showUav: false, // 显示无人机
  showVehicle: false, // 显示车辆
  showEquipment: false, // 显示设备
  showPersonnel: false, // 显示人员
  showLeftMenu: false,
  showRightMenu: false,
  showNavBar: false,
  beginRang: false,
  changeMap: false, // 定位地图
  showStatistical: false,
  changeType: '',
  changePoint: {},
  user: {
    name: 'admin',
    image: 'http://img0.imgtn.bdimg.com/it/u=1993510220,1126153963&fm=214&gp=0.jpg'
  },
  noticeInfo:{
    url:'',
    title:''
  },
  isShowRights:false,
  taskDetails:'',
  heartss:'-1',
  isClose:'',
  addMail:0,
  unreadCount:0,
  infoMap: {},
  messages: [],
  chatopid:0,
  lbcolors:'34376b',
  logo:'',
  // 会话列表
  sessions: [],
  // 当前会话
  currentSessionId: 20,
  // 筛选会话关键词
  filterKey: '',
  msgMap:{},
  prePageInfo:{},
  //消息个数
  NumberMessages:0,
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js